import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import classNames from 'classnames';

import md5 from 'js-md5';

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"
import Helper from "composer/Helper.jsx"

import {
  withStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Checkbox,
  Tooltip,
  Typography,
  Icon,
  IconButton,
  Button,
} from '@material-ui/core';

import { pink } from '@material-ui/core/colors'

class StorageTable extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      order: 'desc',
      orderBy: 'locale_size',
      selected: [],
      page: 0,
      rowsPerPage: 10,

      deleteOption: -1,
      chosenLocaleId: -1,
    };
    autoBind(this);
  }

  deleteFileClicked(option, localeId) {
    this.setState({
      deleteOption: option,
      chosenLocaleId: localeId,
    });

    let confirmTitle = "Delete ";
    switch(option) {
      case 0:
        confirmTitle += "unused files";
        break;
      case 1:
        confirmTitle += "student answer";
        break;
      case 2:
        confirmTitle += "everything";
        break;
      default:
        break;
    }

    let dialogText = {
      title: confirmTitle,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    }
    this.props.root.refs.confirmDialog.show(dialogText, this.deleteFileConfirmClicked, this.deleteFileCancelClicked);
  }

  deleteFileConfirmClicked() {
    let requestObj = {};
    requestObj['locale_id'] = this.state.chosenLocaleId;
    switch (this.state.deleteOption) {
      case 0:
        this.props.root.refs.API.request("clear_locale_zombie_files", requestObj, this.clearLocaleZombieFilesOK, this.clearLocaleZombieFilesFailed);
        break;
      case 1:
        this.props.root.refs.API.request("clear_locale_ans_files", requestObj, this.clearLocaleAnswerFilesOK, this.clearLocaleAnswerFilesFailed);
        break;
      case 2:
        let tmpList = this.props.parent.state.deletedLocaleList;
        tmpList.push(this.state.chosenLocaleId);
        this.props.parent.setState({ deletedLocaleList: tmpList });

        let salt = Config.GET_MD5_KILL_SALT();
        let security_key = salt + this.state.chosenLocaleId + salt;
        requestObj['security_key'] = md5(security_key);
        this.props.root.refs.API.request("kill_locale", requestObj, this.killLocaleOK, this.killLocaleFailed);
        break;
      default:
        break;
    }
  }

  deleteFileCancelClicked() {

  }

  clearLocaleZombieFilesOK(res) {
    this.props.parent.reload();
  }

  clearLocaleZombieFilesFailed(err) {
    console.log("clear locale zombie files failed");
  }

  clearLocaleAnswerFilesOK(res) {
    this.props.parent.reload();
  }

  clearLocaleAnswerFilesFailed(err) {
    console.log("clear locale answer files failed");
  }

  killLocaleOK(res) {
    this.props.parent.reload();
  }

  killLocaleFailed(err) {
    console.log("kill locale failed");
  }

  deleteSelectedLocaleClicked() {
    let dialogText = {
      title: Localization.strings.DELETE,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    }
    this.props.root.refs.confirmDialog.show(dialogText, this.deleteSelectedLocaleConfirmClicked, this.deleteSelectedLocaleCancelClicked);
  }

  deleteSelectedLocaleConfirmClicked() {
    this.deleteSelectedLocale();
  }

  deleteSelectedLocaleCancelClicked() {

  }

  deleteSelectedLocale() {
    let tmpList = this.props.parent.state.deletedLocaleList;
    for (let i = 0; i < this.state.selected.length; i++) {
      tmpList.push(this.state.selected[i]);
    }
    this.props.parent.setState({ deletedLocaleList: tmpList });

    for (let i = 0; i < this.state.selected.length; i++) {
      let salt = Config.GET_MD5_KILL_SALT();
      let security_key = salt + this.state.selected[i] + salt;

      let requestObj = {};
      requestObj['locale_id'] = this.state.selected[i];
      requestObj['security_key'] = md5(security_key);
      this.props.root.refs.API.request("kill_locale", requestObj, this.deleteSelectedLocaleOK, this.deleteSelectedLocaleFailed);
    }
  }

  deleteSelectedLocaleOK(res) {
    this.props.parent.reload();
  }

  deleteSelectedLocaleFailed(err) {
    console.log("delete selected locale failed");
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
    this.state.order = order;
    this.state.orderBy = orderBy;

    this.props.parent.switchSortOrder();
    switch(this.state.orderBy) {
      case "is_hidden":
        this.props.parent.sortNumericDataBy("is_hidden");
        break;
      case "locale_name":
        this.props.parent.sortAlphabetDataBy("locale_name");
        break;
      case "user_display_name":
        this.props.parent.sortAlphabetDataBy("user_display_name");
        break;
      case "locale_size":
        this.props.parent.sortNumericDataBy("locale_size");
        break;
      case "ans_size":
        this.props.parent.sortNumericDataBy("ans_size");
        break;
      default:
        break;
    }
  }

  handleSelectAllClick = event => {
    if (event.target.checked) {
      this.setState({ selected: this.props.data.map(n => n.locale_id) });
      return;
    }
    this.setState({
      selected: [],
    })
  }

  deselectAll() {
    this.setState({ selected: [] });
    this.state.selected = [];
  }

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
    this.state.selected = newSelected;
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  render() {
    const { orderBy, selected, rowsPerPage, page } = this.state;

    return (
      <div>
        <EnhancedTableToolbar
          numSelected={selected.length}
          onDeleteLocale={this.deleteSelectedLocaleClicked}
        />
        <Table>
          <EnhancedTableHead
            numSelected={selected.length}
            order={(this.props.parent.state.sortInAsc? "asc" : "desc")}
            orderBy={orderBy}
            onSelectAllClick={this.handleSelectAllClick}
            onRequestSort={this.handleRequestSort}
            rowCount={this.props.data.length}
          />
          <TableBody>
            {this.props.data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(row => {
                let isSelected = this.isSelected(row['locale_id'])
                return (
                  <TableRow
                    hover
                    onClick={event => this.handleClick(event, row['locale_id'])}
                    role="checkbox"
                    key={row['locale_id']}
                    selected={isSelected}
                  >
                    <TableCell>
                      <Checkbox checked={isSelected}/>
                    </TableCell>
                    <TableCell>
                      <If condition={row['is_hidden'] == 0}>
                        <Then>
                          <Icon color="primary">check_circle</Icon>
                        </Then>
                        <Else>
                          <Icon color="disabled">remove_circle</Icon>
                        </Else>
                      </If>
                    </TableCell>
                    <TableCell>{row['locale_name']}</TableCell>
                    <TableCell>{row['user_display_name']}</TableCell>
                    <TableCell>{Helper.getFileSizeStr(row['locale_size'])}</TableCell>
                    <TableCell>{Helper.getFileSizeStr(row['ans_size'])}</TableCell>
                    <TableCell>
                      <div onClick={(e)=>e.stopPropagation()}>
                        <Tooltip title={Localization.strings.UNUSED_FILES}>
                          <IconButton onClick={()=>this.deleteFileClicked(0, row['locale_id'])}>
                            <Icon>insert_drive_file</Icon>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={Localization.strings.STUDENT_ANSWER}>
                          <IconButton onClick={()=>this.deleteFileClicked(1, row['locale_id'])}>
                            <Icon>face</Icon>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={Localization.strings.EVERYTHING}>
                          <IconButton onClick={()=>this.deleteFileClicked(2, row['locale_id'])}>
                            <Icon>delete_forever</Icon>
                          </IconButton>
                        </Tooltip>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })
            }
            <TableRow>
              <TableCell>{Localization.strings.TOTAL}</TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>{Helper.getFileSizeStr(this.props.parent.getAllLocaleSize())}</TableCell>
              <TableCell>{Helper.getFileSizeStr(this.props.parent.getAllAnswerSize())}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={this.props.data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={this.handleChangePage}
        />
      </div>
    )
  }
}

export default StorageTable;

class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;

    let rows = [
      { id: 'is_hidden', label: Localization.strings.STATUS },
      { id: 'locale_name', label: Localization.strings.VITALS_NAME },
      { id: 'user_display_name', label: Localization.strings.DISPLAY_NAME },
      { id: 'locale_size', label: Localization.strings.VITALS_SIZE },
      { id: 'ans_size', label: Localization.strings.ANSWER_SIZE },
    ]

    return (
      <TableHead>
        <TableRow>
          <TableCell>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount && rowCount > 0}
              onChange={onSelectAllClick}
            />
          </TableCell>
          {rows.map( row => (
            <TableCell
              key={row.id}
              sortDirection={orderBy === row.id ? order : false}
            >
              <Tooltip
                title={Localization.strings.SORT}
              >
                <TableSortLabel
                  active={orderBy === row.id}
                  direction={order}
                  onClick={this.createSortHandler(row.id)}
                >
                  {row.label}
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ))}
          <TableCell>
            {Localization.strings.DELETE_FILE}
          </TableCell>
        </TableRow>
      </TableHead>
    );
  }
}

const toolbarStyles = theme => ({
  root: {
    paddingRight: '14px',
  },
  highlight: {
    color: pink["A400"],
    backgroundColor: pink[50],
  },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: pink["A400"],
  },
  title: {
    flex: '0 0 auto',
  },
});

let EnhancedTableToolbar = props => {
  const { numSelected, classes, onDeleteLocale } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <Button color="secondary" onClick={onDeleteLocale}>
            <Icon className="buttonIconLeft">delete</Icon>
            {Localization.strings.DELETE}
          </Button>
        ) : (
          ""
        )}
      </div>
    </Toolbar>
  );
}

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);
